/**
 * How a mapping row between a {@code ci.InsurableObjectTypeField} and a cw object field behaves at
 * runtime — one-way pre-fill only, or a bound value that is also written back onto the source object.
 *
 * Mirrors the backend enum {@code com.mvs.backend.cw.enums.CwFieldMappingBehaviourEnum}
 * (apps/backend/api/src/main/java/com/mvs/backend/cw/enums/CwFieldMappingBehaviourEnum.java).
 * The backend persists it via {@code @Enumerated(EnumType.ORDINAL)} — ordinals are stable,
 * append-only and MUST match the backend declaration order exactly. Never reorder, never insert:
 * DEFAULT, BIND.
 *
 * Semantics:
 *  - DEFAULT (ordinal 0, "Vorbelegen") — one-way pre-fill: the value is copied from the insurable
 *    object into the cw field; later edits stay on the cw side.
 *  - BIND (ordinal 1, "Binden") — pre-fill PLUS write-back: the captured value is additionally
 *    written onto the source insurable object.
 *
 * Carried by {@code cw.CwCaseTypeObjectFieldIotField.mappingBehaviour} and
 * {@code cw.CwCaseTypeProductObjectFieldIotField.mappingBehaviour}.
 */
export enum CwFieldMappingBehaviourEnum {
    DEFAULT,
    BIND,
}
